<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <main class="main-content position-relative border-radius-lg ">
      <!-- Navbar -->
      <HeaderMenu></HeaderMenu>
      <!-- End Navbar -->
      <div class="container-fluid pt-6" style="min-height: 100vh;">
        <div v-for="(notification, index) in notifications" :key="index" class="alert position-fixed top-0 end-0 m-3"
             :class="notification.class" role="alert" style="color: white; z-index: 9999; max-width: 360px;">
          {{ notification.message }}
          <button style="font-size: small" type="button" class="btn-close" @click="closeNotification(index)"
                  aria-label="Close"></button>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="card mb-4">
              <div class="card-header pb-0 d-flex">
                <h6>Esquemas</h6>
                <button @click="nuevoEsquema" class="btn btn-primary btn-sm ms-auto">Nuevo</button>
              </div>
              <div class="card-body px-0 pt-0 pb-2">
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <tbody>
                    <tr v-for="esquema in esquemas" v-bind:key="esquema.id" @click="esquemaSeleccionado=esquema" :class="{ 'selected-row': esquemaSeleccionado && esquemaSeleccionado.id === esquema.id }">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="avatar avatar-sm me-3"
                               style="display: grid;justify-content: center;align-items: center;"
                               :style="{ backgroundColor: esquema.color }">
                            <i :class="esquema.icono" style="font-size: x-large;color: white"></i>
                          </div>
                          <div class="d-flex flex-column justify-content-center">
                            <p class="text-xs text-secondary mb-0">{{ esquema.grupo }}</p>
                            <h6 class="mb-0 text-sm">{{ esquema.nombre }}</h6>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-9">
            <div class="container-fluid">
              <div class="card">
                <div class="card-header pb-0">
                  <div class="d-flex align-items-center">
                    <p class="mb-0 text-uppercase">Datos esquema</p>
                    <button @click="guardarEsquema" class="btn btn-primary btn-sm ms-auto">Guardar</button>
                  </div>
                </div>
                <div class="card-body">
                  <!-- Sección: Información Básica -->
                  <div class="row mt-2">
                    <div class="col-12">
                      <h6 class="text-sm font-weight-bold text-uppercase text-muted mb-2">
                        <i class="fas fa-info-circle me-2"></i>Información Básica
                      </h6>
                      <div class="row g-2">
                        <div class="col-md-4">
                          <div class="card border border-primary">
                            <div class="card-body p-2">
                              <label class="form-control-label fw-bold mb-1 d-block">Grupo</label>
                              <input type="text" class="form-control"
                                     v-model="esquemaSeleccionado.grupo"
                                     placeholder="Ej: Contabilidad">
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="card border border-primary">
                            <div class="card-body p-2">
                              <label class="form-control-label fw-bold mb-1 d-block">Nombre</label>
                              <input type="text" class="form-control"
                                     v-model="esquemaSeleccionado.nombre"
                                     placeholder="Ej: Facturas">
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="card border">
                            <div class="card-body p-2">
                              <label class="form-control-label text-sm fw-bold mb-1 d-block">Color</label>
                              <input type="color" class="form-control form-control-color w-100" v-model="esquemaSeleccionado.color" style="height: 40px;">
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="card border">
                            <div class="card-body p-2">
                              <label class="form-control-label text-sm fw-bold mb-1 d-block">Icono</label>
                              <div class="d-flex align-items-center gap-1">
                                <i :class="esquemaSeleccionado.icono" style="font-size: x-large; color: black"></i>
                                <IconInput v-model="esquemaSeleccionado.icono"/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Sección: Funcionalidades Básicas -->
                  <div class="row mt-2">
                    <div class="col-12">
                      <h6 class="text-sm font-weight-bold text-uppercase text-muted mb-2">
                        <i class="fas fa-cog me-2"></i>Funcionalidades Básicas
                      </h6>
                      <div class="row g-2 funcionalidades-basicas-row">
                        <div class="col-md-3 mb-2">
                          <div class="card border">
                            <div class="card-body p-2">
                              <label class="form-control-label fw-bold mb-1 d-block">Nombrado automático de documentos</label>
                              <AutonombreInput v-model="esquemaSeleccionado.autonombre" :propiedades="esquemaSeleccionado.propiedades" />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="card border">
                            <div class="card-body p-2">
                              <div class="d-flex align-items-center justify-content-between">
                                <div>
                                  <label class="form-check-label mb-0 fw-bold">Guardar Versiones</label>
                                  <p class="text-xs text-muted mb-0">Mantener historial de versiones</p>
                                </div>
                                <div class="form-check form-switch ms-2">
                                  <input class="form-check-input" type="checkbox" 
                                    @input="marcarVersionado" 
                                    :checked="esquemaSeleccionado.versionado">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="features.ocr_disponible" class="col-md-3">
                          <div class="card border">
                            <div class="card-body p-2">
                              <div class="d-flex align-items-center justify-content-between">
                                <div>
                                  <label class="form-check-label mb-0 fw-bold">OCR</label>
                                  <p class="text-xs text-muted mb-0">Reconocimiento óptico de caracteres</p>
                                </div>
                                <div class="form-check form-switch ms-2">
                                  <input class="form-check-input" type="checkbox" 
                                    @input="marcarOCR" 
                                    :checked="esquemaSeleccionado.ocr">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="features.documentos_relacionados_disponible" class="col-md-3">
                          <div class="card border">
                            <div class="card-body p-2">
                              <div class="d-flex align-items-center justify-content-between">
                                <div>
                                  <label class="form-check-label mb-0 fw-bold">Documentos Relacionados</label>
                                  <p class="text-xs text-muted mb-0">Vincular documentos entre sí</p>
                                </div>
                                <div class="form-check form-switch ms-2">
                                  <input class="form-check-input" type="checkbox" 
                                    @input="marcarDocumentosRelacionados" 
                                    :checked="esquemaSeleccionado.documentos_relacionados">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Sección: Firma de Documentos -->
                  <div v-if="features.firmar_documentos_disponible || features.firmar_documentos_vidsigner_disponible" class="row mt-2">
                    <div class="col-12">
                      <h6 class="text-sm font-weight-bold text-uppercase text-muted mb-2">
                        <i class="fas fa-pen-fancy me-2"></i>Firma de Documentos
                      </h6>
                      <div class="row g-2">
                        <div v-if="features.firmar_documentos_disponible" class="col-md-6">
                          <div class="card border">
                            <div class="card-body p-2">
                              <div class="d-flex align-items-center justify-content-between">
                                <div>
                                  <label class="form-check-label mb-0 fw-bold">Firma en Pantalla</label>
                                  <p class="text-xs text-muted mb-0">Firmar documentos directamente en pantalla</p>
                                </div>
                                <div class="form-check form-switch ms-3">
                                  <input class="form-check-input" type="checkbox" 
                                    @input="marcarFirmarDocumentos" 
                                    :checked="esquemaSeleccionado.firmar_documentos">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="features.firmar_documentos_vidsigner_disponible" class="col-md-6">
                          <div class="card border">
                            <div class="card-body p-2">
                              <div class="d-flex align-items-center justify-content-between">
                                <div>
                                  <label class="form-check-label mb-0 fw-bold">Firma con VidSigner</label>
                                  <p class="text-xs text-muted mb-0">Firmar documentos mediante VidSigner</p>
                                </div>
                                <div class="form-check form-switch ms-3">
                                  <input class="form-check-input" type="checkbox" 
                                    @input="marcarFirmarDocumentosVidsigner" 
                                    :checked="esquemaSeleccionado.firmar_documentos_vidsigner">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Sección: Aprobación y Caducidad -->
                  <div v-if="features.aprobacion_documentos_disponible || features.caducidad_documentos_disponible" class="row mt-2">
                    <div class="col-12">
                      <h6 class="text-sm font-weight-bold text-uppercase text-muted mb-2">
                        <i class="fas fa-shield-alt me-2"></i>Aprobación y Caducidad
                      </h6>
                      <div class="row g-2">
                        <div v-if="features.aprobacion_documentos_disponible" class="col-md-4">
                          <div class="card border">
                            <div class="card-body p-2">
                              <div class="d-flex align-items-center justify-content-between">
                                <div>
                                  <label class="form-check-label mb-0 fw-bold">Aprobación</label>
                                  <p class="text-xs text-muted mb-0">Los documentos necesitan ser aprobados</p>
                                </div>
                                <div class="form-check form-switch ms-3">
                                  <input class="form-check-input" type="checkbox" 
                                    @input="marcarRequiereAprobacion" 
                                    :checked="esquemaSeleccionado.requiere_aprobacion">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="features.aprobacion_avanzada_disponible" class="col-md-4">
                          <div class="card border">
                            <div class="card-body p-2">
                              <div class="d-flex align-items-center justify-content-between">
                                <div>
                                  <label class="form-check-label mb-0 fw-bold">Aprobación Avanzada</label>
                                  <p class="text-xs text-muted mb-0">Reglas de aprobación por importe y departamento</p>
                                </div>
                                <div class="form-check form-switch ms-3">
                                  <input class="form-check-input" type="checkbox" 
                                    @input="marcarAprobacionAvanzada" 
                                    :checked="esquemaSeleccionado.aprobacion_avanzada">
                                </div>
                              </div>
                              <div v-if="esquemaSeleccionado.aprobacion_avanzada" class="mt-2 pt-2 border-top">
                                <router-link :to="`/aprobacion-avanzada?esquema=${esquemaSeleccionado.id}`" class="btn btn-sm btn-outline-primary w-100">
                                  <i class="fas fa-cog me-2"></i>Configurar reglas
                                </router-link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="features.caducidad_documentos_disponible" class="col-md-4">
                          <div class="card border">
                            <div class="card-body p-2">
                              <div class="d-flex align-items-center justify-content-between mb-2">
                                <div>
                                  <label class="form-check-label mb-0 fw-bold">Caducidad</label>
                                  <p class="text-xs text-muted mb-0">Los documentos tienen fecha de caducidad</p>
                                </div>
                                <div class="form-check form-switch ms-3">
                                  <input class="form-check-input" type="checkbox" 
                                    @input="marcarTieneCaducidad" 
                                    :checked="esquemaSeleccionado.tiene_caducidad">
                                </div>
                              </div>
                              <div v-if="esquemaSeleccionado.tiene_caducidad" class="mt-2 pt-2 border-top">
                                <label class="form-control-label text-sm fw-bold mb-2">Propiedad de Caducidad</label>
                                <select class="form-control form-control-sm" v-model="esquemaSeleccionado.propiedad_caducidad_id">
                                  <option value="">Selecciona una propiedad</option>
                                  <option v-for="prop in propiedadesFecha" :key="prop.id" :value="prop.id">
                                    {{ prop.nombre }}
                                  </option>
                                </select>
                                <small class="text-muted text-xs d-block mt-2">
                                  <i class="fas fa-info-circle me-1"></i>Será obligatoria para todos los documentos
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Sección: Plantilla Word -->
                  <div v-if="features.plantillas_word_disponible" class="row mt-2">
                    <div class="col-12">
                      <h6 class="text-sm font-weight-bold text-uppercase text-muted mb-2">
                        <i class="fas fa-file-word me-2"></i>Plantilla Word
                      </h6>
                      <div class="row g-2">
                        <div class="col-md-4">
                          <div class="card border">
                            <div class="card-body p-2">
                              <div class="d-flex align-items-center justify-content-between">
                                <div>
                                  <label class="form-check-label mb-0 fw-bold">Plantilla Word</label>
                                  <p class="text-xs text-muted mb-0">
                                    <span v-if="tienePlantilla" class="text-success">
                                      <i class="fas fa-check-circle me-1"></i>Plantilla configurada
                                    </span>
                                    <span v-else class="text-muted">
                                      <i class="fas fa-times-circle me-1"></i>Sin plantilla
                                    </span>
                                  </p>
                                </div>
                                <button 
                                  @click="mostrarModalPlantilla = true" 
                                  class="btn btn-sm btn-outline-primary ms-3"
                                  :disabled="!esquemaSeleccionado.id"
                                >
                                  <i class="fas fa-cog me-1"></i>Gestionar
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr class="horizontal dark">
                  <p class="text-uppercase text-sm">Propiedades</p>
                  <button class="btn btn-primary btn-sm" @click="mostrarModalNuevaPropiedad = true">Añadir Propiedad</button>
                  <div class="row">
                    <div class="col-md-12">

                      <!-- Mostrar lista de propiedades agrupadas por grupo -->
                      <div v-if="esquemaSeleccionado.propiedades && esquemaSeleccionado.propiedades.length > 0">
                        <div v-for="grupo in propiedadesAgrupadas" :key="'grupo_' + grupo.nombre">
                          <h6 class="mt-3">{{ grupo.nombre }}</h6>
                          <ul class="list-group">
                            <li v-for="item in grupo.items" :key="'prop_' + item.index" class="list-group-item d-flex justify-content-between align-items-center">
                              <div v-if="!item.propiedad.editando" class="d-flex w-100 justify-content-between">
                                <div class="w-15">
                                  <span class="ms-2">{{ item.propiedad.orden }}</span>
                                </div>
                                <div class="d-flex w-30 justify-content-between">
                                  <strong>{{ item.propiedad.nombre }}</strong>
                                </div>
                                <div class="w-15">
                                  <span class="ms-2">{{ tiposDatos.find((tipo) => tipo.value === item.propiedad.tipo).label }}</span>
                                  <span v-if="item.propiedad.tipo === 'lista' && item.propiedad.lista_id" class="ms-1 text-muted">
                                    ({{ listasDisponibles.find(l => l.id === item.propiedad.lista_id)?.descripcion }})
                                  </span>
                                </div>
                                <div class="w-15">
                                  <span>{{ item.propiedad.obligatorio ? 'Obligatorio' : 'Opcional' }}</span>
                                </div>
                                <div class="w-15">
                                  <span>{{ item.propiedad.genera_version ? (esquemaSeleccionado.versionado ? 'Genera Versión' : 'Genera Sustitución') : '' }}</span>
                                </div>
                                <div class="d-flex">
                                  <button @click="editarPropiedad(item.index)" class="btn btn-warning btn-sm me-1">Editar</button>
                                  <button @click="eliminarPropiedad(item.index)" class="btn btn-danger btn-sm">Eliminar</button>
                                </div>
                              </div>
                              <!-- Campos editables -->
                              <div v-else class="d-flex w-100 justify-content-between">
                                <div class="d-flex justify-content-between w-85">
                                  <input v-model.number="item.propiedad.orden" class="form-control form-control-sm" style="max-width: 100px" type="number" placeholder="Orden" />
                                  <input v-model="item.propiedad.grupo" class="form-control form-control-sm" style="max-width: 200px" />
                                  <input v-model="item.propiedad.nombre" class="form-control form-control-sm" style="max-width: 200px" />
                                  <div style="max-width: 120px">
                                    <select v-model="item.propiedad.tipo" class="form-control form-control-sm" >
                                      <option v-for="(tipoDato, index) in tiposDatos" v-bind:key="index" :value="tipoDato.value">{{tipoDato.label}}</option>
                                    </select>
                                    <select v-if="item.propiedad.tipo === 'list'" v-model="item.propiedad.lista_id" class="form-control form-control-sm" style="max-width: 150px">
                                      <option value="">Selecciona una lista</option>
                                      <option v-for="lista in listasDisponibles" :key="lista.id" :value="lista.id">
                                        {{ lista.descripcion }}
                                      </option>
                                    </select>
                                  </div>
                                  <div class="d-flex align-items-center"><input type="checkbox" v-model="item.propiedad.obligatorio" /> Obligatorio</div>
                                  <div class="d-flex align-items-center"><input type="checkbox" v-model="item.propiedad.genera_version" />{{ (esquemaSeleccionado.versionado ? 'Genera Versión' : 'Genera Sustitución') }}</div>
                                </div>
                                <div class="w-15 d-flex justify-content-end">
                                  <button @click="guardarPropiedad(item.index)" class="btn btn-success btn-sm me-1">Guardar</button>
                                  <button @click="cancelarEdicion(item.index)" class="btn btn-secondary btn-sm">Cancelar</button>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

  <!-- Modal Nueva Propiedad -->
  <div v-if="mostrarModalNuevaPropiedad" class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.3);">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Añadir Propiedad</h5>
          <button type="button" class="btn-close" @click="mostrarModalNuevaPropiedad = false"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="mb-3">
              <label class="form-label">Grupo</label>
              <input type="text" class="form-control" v-model="nuevaPropiedad.grupo" required />
            </div>
            <div class="mb-3">
              <label class="form-label">Nombre</label>
              <input type="text" class="form-control" v-model="nuevaPropiedad.nombre" required />
            </div>
            <div class="mb-3">
              <label class="form-label">Tipo de Dato</label>
              <select class="form-control" v-model="nuevaPropiedad.tipo" required>
                <option v-for="(tipoDato,index) in tiposDatos" :key="index" :value="tipoDato.value">{{tipoDato.label}}</option>
              </select>
            </div>
            <div class="mb-3" v-if="nuevaPropiedad.tipo === 'list'">
              <label class="form-label">Lista</label>
              <select class="form-control" v-model="nuevaPropiedad.lista_id" required>
                <option value="">Selecciona una lista</option>
                <option v-for="lista in listasDisponibles" :key="lista.id" :value="lista.id">
                  {{ lista.descripcion }}
                </option>
              </select>
            </div>
            <div class="form-check mb-3">
              <input class="form-check-input" type="checkbox" id="np-obligatorio" v-model="nuevaPropiedad.obligatorio">
              <label class="form-check-label" for="np-obligatorio">Obligatorio</label>
            </div>
            <div class="mb-3">
              <label class="form-label">Orden</label>
              <input type="number" class="form-control" v-model.number="nuevaPropiedad.orden" />
            </div>
            <div class="form-check mb-3">
              <input class="form-check-input" type="checkbox" id="np-generaversion" v-model="nuevaPropiedad.genera_version">
              <label class="form-check-label" for="np-generaversion">Genera versión</label>
            </div>
            <div class="d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-secondary" @click="mostrarModalNuevaPropiedad = false">Cancelar</button>
              <button type="button" class="btn btn-primary" @click="agregarPropiedad">Agregar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Gestionar Plantilla Word -->
  <div v-if="mostrarModalPlantilla" class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.3);">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="fas fa-file-word me-2"></i>Gestionar Plantilla Word
          </h5>
          <button type="button" class="btn-close" @click="cerrarModalPlantilla"></button>
        </div>
        <div class="modal-body">
          <!-- Estado de la plantilla -->
          <div v-if="tienePlantilla" class="mb-3">
            <div class="alert alert-success-custom d-flex align-items-center justify-content-between">
              <div>
                <i class="fas fa-check-circle me-2"></i>
                <strong>Plantilla Word configurada</strong>
              </div>
              <button 
                @click="descargarPlantilla" 
                class="btn btn-sm btn-outline-primary"
                :disabled="descargandoPlantilla"
              >
                <i class="fas fa-download me-2"></i>
                {{ descargandoPlantilla ? 'Descargando...' : 'Descargar plantilla' }}
              </button>
            </div>
          </div>
          <div v-else class="mb-3">
            <div class="alert alert-info-custom d-flex align-items-center">
              <i class="fas fa-info-circle me-2"></i>
              <span>No hay plantilla configurada para este esquema</span>
            </div>
          </div>

          <!-- Subir/Actualizar Plantilla -->
          <div class="mb-3">
            <label class="form-control-label fw-bold mb-2">Subir/Actualizar Plantilla Word</label>
            <input 
              type="file" 
              ref="fileInputPlantilla" 
              accept=".doc,.docx"
              @change="onFileSelected"
              class="form-control form-control-sm"
            />
            <small class="text-muted d-block mt-2">
              <i class="fas fa-info-circle me-1"></i>Formatos aceptados: .doc, .docx
            </small>
          </div>
          
          <div class="d-flex gap-2 mb-3">
            <button 
              @click="subirPlantilla" 
              :disabled="!archivoPlantillaSeleccionado || subiendoPlantilla"
              class="btn btn-sm btn-primary"
            >
              <i class="fas fa-upload me-2"></i>
              {{ subiendoPlantilla ? 'Subiendo...' : (tienePlantilla ? 'Actualizar' : 'Subir') }} Plantilla
            </button>
            <button 
              v-if="tienePlantilla"
              @click="eliminarPlantilla" 
              class="btn btn-sm btn-outline-danger"
            >
              <i class="fas fa-trash me-2"></i>Eliminar plantilla
            </button>
          </div>

          <!-- Ayuda: Variables en Plantillas -->
          <div class="mt-4 pt-3 border-top">
            <h6 class="fw-bold mb-2">Ayuda: Variables en Plantillas</h6>
            <p class="text-sm text-muted mb-2">
              Usa variables en tu plantilla Word con el formato: <code v-html="'$&#123;NOMBRE_PROPIEDAD&#125;'"></code>
            </p>
            <p class="text-sm text-muted mb-3">
              Las propiedades disponibles son:
            </p>
            <div v-if="esquemaSeleccionado.propiedades && esquemaSeleccionado.propiedades.length > 0" class="row g-2">
              <div v-for="prop in esquemaSeleccionado.propiedades" :key="prop.id" class="col-md-4">
                <code class="text-sm" v-html="formatearVariable(prop.campoBD)"></code>
                <span class="text-muted text-xs ms-2">- {{ prop.nombre }}</span>
              </div>
            </div>
            <div v-else class="text-muted text-sm">
              <i class="fas fa-info-circle me-1"></i>No hay propiedades configuradas aún
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="cerrarModalPlantilla">Cerrar</button>
        </div>
      </div>
    </div>
  </div>

  </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu.vue";
import {onMounted, ref, reactive, computed} from "vue";
import axiosInstance from "@/axios";
import IconInput from "@/components/IconInput";
import AutonombreInput from "@/components/AutonombreInput.vue";

export default {
  name: "EsquemasView",
  components: {HeaderMenu, IconInput, AutonombreInput},
  setup() {
    const esquemas = ref([]);
    const esquemaSeleccionado = ref({id:'',grupo:'',nombre:'',icono:'',color:'',versionado:false,propiedades: [], firmar_documentos:false, firmar_documentos_vidsigner:false, requiere_aprobacion:false, tiene_caducidad:false, propiedad_caducidad_id:null, aprobacion_avanzada:false, plantilla_word:null});
    const notifications = ref([]);
    const listasDisponibles = ref([]);
    const archivoPlantillaSeleccionado = ref(null);
    const subiendoPlantilla = ref(false);
    const descargandoPlantilla = ref(false);
    const fileInputPlantilla = ref(null);
    const mostrarModalPlantilla = ref(false);
    const features = ref({
      ocr_disponible: false,
      documentos_relacionados_disponible: false,
      firmar_documentos_disponible: false,
      firmar_documentos_vidsigner_disponible: false,
      aprobacion_documentos_disponible: false,
      caducidad_documentos_disponible: false,
      aprobacion_avanzada_disponible: false,
      plantillas_word_disponible: false
    });

    // Función para cerrar una notificación
    const closeNotification = (index) => {
      notifications.value.splice(index, 1);
    };

    onMounted(async () => {
      try {
        const response = await axiosInstance.get("/api/esquemas");
        // Nueva estructura: { esquemas: [...], features: {...} }
        if (response.data.esquemas && Array.isArray(response.data.esquemas)) {
          esquemas.value = response.data.esquemas;
          if (response.data.features) {
            features.value = {
              ocr_disponible: response.data.features.ocr_disponible ?? false,
              documentos_relacionados_disponible: response.data.features.documentos_relacionados_disponible ?? false,
              firmar_documentos_disponible: response.data.features.firmar_documentos_disponible ?? false,
              firmar_documentos_vidsigner_disponible: response.data.features.firmar_documentos_vidsigner_disponible ?? false,
              aprobacion_documentos_disponible: response.data.features.aprobacion_documentos_disponible ?? false,
              caducidad_documentos_disponible: response.data.features.caducidad_documentos_disponible ?? false,
              aprobacion_avanzada_disponible: response.data.features.aprobacion_avanzada_disponible ?? false,
              plantillas_word_disponible: response.data.features.plantillas_word_disponible ?? false
            };
          }
          if (esquemas.value.length > 0) {
            esquemaSeleccionado.value = esquemas.value[0];
          }
        } else if (Array.isArray(response.data)) {
          // Compatibilidad con estructura antigua
          esquemas.value = response.data;
          if (response.data.length > 0) {
            esquemaSeleccionado.value = response.data[0];
          }
        }
      } catch (error) {
        console.error("Error al obtener los esquemas", error);
      }

      // Cargar listas disponibles
      try {
        const listasResponse = await axiosInstance.get("/api/listas");
        listasDisponibles.value = listasResponse.data.data || [];
      } catch (error) {
        console.error("Error al obtener las listas", error);
      }
      esquemas.value.forEach(esquema => {
        if (Array.isArray(esquema.propiedades)) {
          esquema.propiedades.forEach(prop => {
            prop.obligatorio = !!prop.obligatorio;
            prop.orden = Number(prop.orden || 0);
            prop.genera_version = !!prop.genera_version;
          });
        }
        esquema.versionado = !!esquema.versionado;
        esquema.ocr = !!esquema.ocr;
        esquema.documentos_relacionados = !!esquema.documentos_relacionados;
        esquema.firmar_documentos = !!esquema.firmar_documentos;
        esquema.firmar_documentos_vidsigner = !!esquema.firmar_documentos_vidsigner;
        esquema.requiere_aprobacion = !!esquema.requiere_aprobacion;
        esquema.tiene_caducidad = !!esquema.tiene_caducidad;
        // plantilla_word viene del backend, si es null no tiene plantilla
        esquema.propiedad_caducidad_id = esquema.propiedad_caducidad_id || null;
        esquema.aprobacion_avanzada = !!esquema.aprobacion_avanzada;
      });
    });

    const propiedadesAgrupadas = computed(() => {
      const gruposMap = new Map();
      const props = esquemaSeleccionado.value?.propiedades || [];
      props.forEach((propiedad, index) => {
        const nombreGrupo = propiedad.grupo || 'Sin grupo';
        if (!gruposMap.has(nombreGrupo)) {
          gruposMap.set(nombreGrupo, []);
        }
        gruposMap.get(nombreGrupo).push({ propiedad, index });
      });
      // ordenar items por 'orden' ascendente
      return Array.from(gruposMap.entries()).map(([nombre, items]) => ({ nombre, items: items.sort((a,b)=> (a.propiedad.orden||0) - (b.propiedad.orden||0)) }));
    });

    const propiedadesFecha = computed(() => {
      return (esquemaSeleccionado.value?.propiedades || []).filter(prop => prop.tipo === 'date');
    });

    const tienePlantilla = computed(() => {
      return esquemaSeleccionado.value?.plantilla_word != null && esquemaSeleccionado.value?.plantilla_word !== '';
    });

    const showNotification = (message, type) => {
      const notification = {
        message,
        class: type,
      };
      notifications.value.push(notification);

      // Cerrar la notificación automáticamente después de 2 segundos
      setTimeout(() => {
        closeNotification(notifications.value.indexOf(notification));
      }, 2000); // 2000 milisegundos = 2 segundos
    };

    const guardarEsquema = async () => {
      try {
        const response = await axiosInstance.post("/api/esquema", {esquema: esquemaSeleccionado.value});
        esquemas.value = response.data.esquemas;
        esquemaSeleccionado.value = response.data.esquemaSeleccionado;
        showNotification('Esquema guardado.', 'alert-success');

      } catch (error) {
        const mensaje = error.response.data.error || 'Error al guardar el esquema.';
        showNotification(mensaje, 'alert-danger');
      }
    };

    const onFileSelected = (event) => {
      const file = event.target.files[0];
      if (file) {
        // Validar que sea un archivo Word
        const validExtensions = ['.doc', '.docx'];
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        if (!validExtensions.includes(fileExtension)) {
          showNotification('Por favor, selecciona un archivo Word (.doc o .docx)', 'alert-warning');
          event.target.value = '';
          archivoPlantillaSeleccionado.value = null;
          return;
        }
        archivoPlantillaSeleccionado.value = file;
      } else {
        archivoPlantillaSeleccionado.value = null;
      }
    };

    const subirPlantilla = async () => {
      if (!archivoPlantillaSeleccionado.value || !esquemaSeleccionado.value.id) {
        showNotification('Por favor, selecciona un archivo y un esquema', 'alert-warning');
        return;
      }

      subiendoPlantilla.value = true;
      try {
        const formData = new FormData();
        formData.append('plantilla', archivoPlantillaSeleccionado.value);

        const response = await axiosInstance.post(
          `/api/esquema/${esquemaSeleccionado.value.id}/plantillaWord`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        if (response.data.success) {
          showNotification('Plantilla guardada correctamente', 'alert-success');
          // Actualizar plantilla_word con la ruta del backend
          if (response.data.ruta) {
            esquemaSeleccionado.value.plantilla_word = response.data.ruta;
          }
          // Limpiar el input
          if (fileInputPlantilla.value) {
            fileInputPlantilla.value.value = '';
          }
          archivoPlantillaSeleccionado.value = null;
          // Recargar el esquema para obtener la información actualizada
          await cargarEsquemaSeleccionado();
        } else {
          showNotification(response.data.error || 'Error al guardar la plantilla', 'alert-danger');
        }
      } catch (error) {
        const mensaje = error.response?.data?.error || 'Error al subir la plantilla';
        showNotification(mensaje, 'alert-danger');
      } finally {
        subiendoPlantilla.value = false;
      }
    };

    const descargarPlantilla = async () => {
      if (!esquemaSeleccionado.value.id || !tienePlantilla.value) {
        showNotification('No hay plantilla para descargar', 'alert-warning');
        return;
      }

      descargandoPlantilla.value = true;
      try {
        const response = await axiosInstance.get(
          `/api/esquema/${esquemaSeleccionado.value.id}/plantillaWord`,
          {
            responseType: 'blob'
          }
        );

        // Crear un enlace temporal para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        
        // Obtener el nombre del archivo del header Content-Disposition o usar un nombre por defecto
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'plantilla.docx';
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
          }
        }
        
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        showNotification('Plantilla descargada correctamente', 'alert-success');
      } catch (error) {
        const mensaje = error.response?.data?.error || 'Error al descargar la plantilla';
        showNotification(mensaje, 'alert-danger');
      } finally {
        descargandoPlantilla.value = false;
      }
    };

    const cerrarModalPlantilla = () => {
      mostrarModalPlantilla.value = false;
      // Limpiar el input al cerrar
      if (fileInputPlantilla.value) {
        fileInputPlantilla.value.value = '';
      }
      archivoPlantillaSeleccionado.value = null;
    };

    const eliminarPlantilla = async () => {
      if (!esquemaSeleccionado.value.id) {
        return;
      }

      if (!confirm('¿Estás seguro de que deseas eliminar la plantilla Word?')) {
        return;
      }

      try {
        const response = await axiosInstance.delete(
          `/api/esquema/${esquemaSeleccionado.value.id}/plantillaWord`
        );

        if (response.data.success) {
          showNotification('Plantilla eliminada correctamente', 'alert-success');
          // Establecer plantilla_word a null cuando se elimina
          esquemaSeleccionado.value.plantilla_word = null;
          // Recargar el esquema para obtener la información actualizada
          await cargarEsquemaSeleccionado();
        } else {
          showNotification(response.data.error || 'Error al eliminar la plantilla', 'alert-danger');
        }
      } catch (error) {
        const mensaje = error.response?.data?.error || 'Error al eliminar la plantilla';
        showNotification(mensaje, 'alert-danger');
      }
    };

    const cargarEsquemaSeleccionado = async () => {
      if (!esquemaSeleccionado.value.id) {
        return;
      }
      try {
        const response = await axiosInstance.get(`/api/datosesquema/${esquemaSeleccionado.value.id}`);
        if (response.data.esquema) {
          // Actualizar solo los campos relevantes, manteniendo las propiedades editadas
          esquemaSeleccionado.value.plantilla_word = response.data.esquema.plantilla_word || null;
        }
      } catch (error) {
        console.error('Error al cargar el esquema:', error);
      }
    };

    const formatearVariable = (campoBD) => {
      return `$&#123;${campoBD.toUpperCase()}&#125;`;
    };

    const nuevoEsquema = () => {
      esquemaSeleccionado.value = {};
    };

    // Definir un objeto para nueva propiedad
    const nuevaPropiedad = reactive({
      grupo: '',
      nombre: '',
      tipo: 'text', // Valor por defecto
      obligatorio: false,
      orden: 0,
      genera_version: false,
      lista_id: null,
    });
    const mostrarModalNuevaPropiedad = ref(false);

    const agregarPropiedad = () => {
      if (nuevaPropiedad.nombre.trim() !== '') {
        esquemaSeleccionado.value.propiedades.push({...nuevaPropiedad}); // Agregar la propiedad al esquema
        // Resetear el formulario después de agregar
        nuevaPropiedad.grupo = null;
        nuevaPropiedad.nombre = '';
        nuevaPropiedad.tipo = 'texto';
        nuevaPropiedad.obligatorio = false;
        nuevaPropiedad.orden = 0;
        nuevaPropiedad.genera_version = false;
        nuevaPropiedad.lista_id = null;
        nuevaPropiedad.grupo = null;

        mostrarModalNuevaPropiedad.value = false;
      }
    };

    // Función para eliminar una propiedad
    const eliminarPropiedad = (index) => {
      esquemaSeleccionado.value.propiedades.splice(index, 1); // Eliminar propiedad de la lista
    };

    // Función para habilitar la edición de la propiedad
    const editarPropiedad = (index) => {
      esquemaSeleccionado.value.propiedades[index].editando = true;
    };

    const cancelarEdicion = (index) => {
      esquemaSeleccionado.value.propiedades[index].editando = false;
      // Restablecer los valores originales de la propiedad
      esquemaSeleccionado.value.propiedades[index] = { ...esquemaSeleccionado.value.propiedades[index] };
    };

    const guardarPropiedad = (index) => {
      esquemaSeleccionado.value.propiedades[index].editando = false;
    };

    const tiposDatos = [
      {'value':'int','label':'Entero'},
      {'value':'decimal','label':'Decimal'},
      {'value':'decimal2','label':'Decimal (2 decimales)'},
      {'value':'decimal4','label':'Decimal (4 decimales)'},
      {'value':'text','label':'Texto'},
      {'value':'longtext','label':'Texto Largo'},
      {'value':'date','label':'Fecha'},
      {'value':'list','label':'Lista'},
    ];

    const marcarVersionado = (event) => {
      esquemaSeleccionado.value.versionado = event.target.checked;
    };

    const marcarOCR = (event) => {
      if (event.target.checked && !features.value.ocr_disponible) {
        event.target.checked = false;
        showNotification('Esta funcionalidad no está disponible en esta instalación', 'alert-warning');
        return;
      }
      esquemaSeleccionado.value.ocr = event.target.checked;
    };

    const marcarDocumentosRelacionados = (event) => {
      if (event.target.checked && !features.value.documentos_relacionados_disponible) {
        event.target.checked = false;
        showNotification('Esta funcionalidad no está disponible en esta instalación', 'alert-warning');
        return;
      }
      esquemaSeleccionado.value.documentos_relacionados = event.target.checked;
    };

    const marcarFirmarDocumentos = (event) => {
      if (event.target.checked && !features.value.firmar_documentos_disponible) {
        event.target.checked = false;
        showNotification('Esta funcionalidad no está disponible en esta instalación', 'alert-warning');
        return;
      }
      esquemaSeleccionado.value.firmar_documentos = event.target.checked;
    };

    const marcarFirmarDocumentosVidsigner = (event) => {
      if (event.target.checked && !features.value.firmar_documentos_vidsigner_disponible) {
        event.target.checked = false;
        showNotification('Esta funcionalidad no está disponible en esta instalación', 'alert-warning');
        return;
      }
      esquemaSeleccionado.value.firmar_documentos_vidsigner = event.target.checked;
    };

    const marcarRequiereAprobacion = (event) => {
      if (event.target.checked && !features.value.aprobacion_documentos_disponible) {
        event.target.checked = false;
        showNotification('Esta funcionalidad no está disponible en esta instalación', 'alert-warning');
        return;
      }
      esquemaSeleccionado.value.requiere_aprobacion = event.target.checked;
    };

    const marcarTieneCaducidad = (event) => {
      if (event.target.checked && !features.value.caducidad_documentos_disponible) {
        event.target.checked = false;
        showNotification('Esta funcionalidad no está disponible en esta instalación', 'alert-warning');
        return;
      }
      esquemaSeleccionado.value.tiene_caducidad = event.target.checked;
      if (!event.target.checked) {
        esquemaSeleccionado.value.propiedad_caducidad_id = null;
      }
    };

    const marcarAprobacionAvanzada = (event) => {
      if (event.target.checked && !features.value.aprobacion_avanzada_disponible) {
        event.target.checked = false;
        showNotification('Esta funcionalidad no está disponible en esta instalación', 'alert-warning');
        return;
      }
      esquemaSeleccionado.value.aprobacion_avanzada = event.target.checked;
      // Si se activa aprobación avanzada, desactivar aprobación simple
      if (event.target.checked) {
        esquemaSeleccionado.value.requiere_aprobacion = false;
      }
    };

    // Autonombre: movido a componente

    

    return {
      esquemas,
      esquemaSeleccionado,
      guardarEsquema,
      notifications,
      closeNotification,
      nuevoEsquema,
      nuevaPropiedad,
      mostrarModalNuevaPropiedad,
      agregarPropiedad,
      eliminarPropiedad,
      editarPropiedad,
      cancelarEdicion,
      guardarPropiedad,
      tiposDatos,
      propiedadesAgrupadas,
      listasDisponibles,
      features,
      propiedadesFecha,
      marcarVersionado,
      marcarOCR,
      marcarDocumentosRelacionados,
      marcarFirmarDocumentos,
      marcarFirmarDocumentosVidsigner,
      marcarRequiereAprobacion,
      marcarTieneCaducidad,
      marcarAprobacionAvanzada,
      tienePlantilla,
      archivoPlantillaSeleccionado,
      subiendoPlantilla,
      descargandoPlantilla,
      fileInputPlantilla,
      mostrarModalPlantilla,
      onFileSelected,
      subirPlantilla,
      eliminarPlantilla,
      descargarPlantilla,
      cerrarModalPlantilla,
      formatearVariable,
    };
  },
}
</script>

<style scoped>
/* Personalización adicional del estilo */

.list-group-item {
  border-radius: 0.375rem;
  padding: 10px 15px;
}

.list-group-item:hover {
  background-color: #f8f9fa;
}

.btn-sm {
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
}

.ms-2 {
  margin-left: 0.5rem;
}

button {
  min-width: 75px;
  text-align: center;
}

.selected-row {
  background-color: #f2f2f2;
}

.funcionalidades-basicas-row {
  display: flex;
  flex-wrap: wrap;
}

.funcionalidades-basicas-row > div {
  display: flex;
}

.funcionalidades-basicas-row .card {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.funcionalidades-basicas-row .card-body {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.alert-success-custom {
  background-color: #d1e7dd;
  border: 1px solid #badbcc;
  color: #0f5132;
}

.alert-info-custom {
  background-color: #cff4fc;
  border: 1px solid #b6effb;
  color: #055160;
}
</style>